import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEOMeta from "component/app/SEOMeta";
import { TermsContent } from "component/common/termsModal";
import { getTermsDocument } from "lang/terms";
import style from "css/termsModal.module.css";

/**
 * 파일명: terms.jsx
 * 설명: 약관 전문 페이지. /terms(이용약관), /privacy(개인정보처리방침) 로 직접 접속해 볼 수 있다.
 *
 * props
 *  - type : "service" | "privacy"
 */
function Terms({ type }) {
  const { i18n } = useTranslation();
  const doc = getTermsDocument(type, i18n.language);

  return (
    <div className={style.page}>
      <SEOMeta
        title={doc.title}
        description={doc.title}
        keywords={doc.title}
      />
      <Link
        to="/"
        className={style.logoLink}
      >
        <img
          alt="all Place"
          src={`${process.env.REACT_APP_CLIENT_URL}img/common/allplace_logo_dark.png`}
        />
      </Link>
      <article className={style.pageCard}>
        <h1 className={style.pageTitle}>{doc.title}</h1>
        <TermsContent doc={doc} />
      </article>
    </div>
  );
}

export default Terms;
